export default {
  "title": "Política de cookies",
  "lastUpdated": "Última actualización: 26 de mayo de 2026",
  "back": "← Volver al inicio",
  "intro": [
    {
      "type": "p",
      "text": "Esta política de cookies explica cómo Demakstore Gıda İhracat San. ve Tic. Ltd. Şti., que opera bajo la marca DeMaxtore («DeMaxtore», «nosotros», «nuestro»), utiliza cookies y tecnologías similares en www.demaxtore.com."
    },
    {
      "type": "p",
      "text": "Al usar nuestro sitio web, puede aceptar, rechazar o gestionar determinadas cookies según su finalidad. Algunas cookies son necesarias para el correcto funcionamiento del sitio; otras mejoran la experiencia, analizan el rendimiento y apoyan actividades de marketing."
    }
  ],
  "sections": [
    {
      "title": "1. Gestionar sus preferencias de cookies",
      "blocks": [
        {
          "type": "p",
          "text": "Algunas funciones de nuestro sitio pueden basarse en servicios de terceros. Si da su consentimiento, esos terceros pueden colocar cookies o tecnologías similares en su dispositivo para permitirle ver, interactuar o compartir contenido alojado por dichos terceros."
        },
        {
          "type": "p",
          "text": "Estas cookies pueden permitir que terceros recopilen y utilicen sus datos de navegación para sus propios fines, de acuerdo con sus políticas de privacidad y cookies."
        },
        {
          "type": "p",
          "text": "Puede otorgar o retirar su consentimiento en cualquier momento, de forma global o por categoría de cookies, cuando dichas opciones estén disponibles."
        },
        {
          "type": "p",
          "text": "Por defecto, no se colocan cookies no esenciales a menos que usted dé su consentimiento, cuando la ley aplicable lo exija."
        }
      ]
    },
    {
      "title": "2. Sobre las cookies",
      "blocks": [
        {
          "type": "p",
          "text": "Utilizamos distintos tipos de cookies en nuestro sitio para garantizar su correcto funcionamiento, medir la audiencia, mejorar el rendimiento y reforzar la interactividad de nuestros servicios."
        },
        {
          "type": "p",
          "text": "Las cookies pueden ayudarnos a entender cómo los visitantes usan nuestro sitio, qué páginas visitan, cómo interactúan con nuestros servicios y cómo mejorar la experiencia."
        }
      ]
    },
    {
      "title": "3. ¿Qué es una cookie?",
      "blocks": [
        {
          "type": "p",
          "text": "Una cookie es un pequeño archivo de texto o información que puede almacenarse en su dispositivo cuando visita un sitio web."
        },
        {
          "type": "p",
          "text": "Las cookies permiten que un sitio reconozca su navegador o dispositivo durante la visita o cuando regresa más tarde. Pueden utilizarse para:"
        },
        {
          "type": "ul",
          "items": [
            "Mantener el sitio seguro",
            "Recordar preferencias",
            "Mantener información de sesión",
            "Medir el tráfico",
            "Mejorar la funcionalidad",
            "Apoyar analítica y marketing",
            "Habilitar contenido o integraciones de terceros"
          ]
        },
        {
          "type": "p",
          "text": "Las cookies pueden ser temporales (se eliminan al cerrar el navegador) o persistentes (permanecen en su dispositivo durante un periodo definido)."
        }
      ]
    },
    {
      "title": "4. Tipos de cookies que utilizamos",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore puede utilizar los siguientes tipos de cookies:"
        }
      ]
    },
    {
      "title": "4.1 Cookies estrictamente necesarias",
      "blocks": [
        {
          "type": "p",
          "text": "Estas cookies son necesarias para que el sitio funcione correctamente. Permiten funciones básicas como:"
        },
        {
          "type": "ul",
          "items": [
            "Navegación",
            "Seguridad",
            "Gestión de sesión",
            "Envío de formularios",
            "Gestión de preferencias de cookies",
            "Acceso a áreas seguras"
          ]
        },
        {
          "type": "p",
          "text": "Puede bloquearlas técnicamente en su navegador, pero algunas partes del sitio podrían dejar de funcionar correctamente."
        },
        {
          "type": "p",
          "text": "Estas cookies no requieren consentimiento cuando son estrictamente necesarias para el funcionamiento del sitio."
        }
      ]
    },
    {
      "title": "4.2 Cookies de rendimiento y analítica",
      "blocks": [
        {
          "type": "p",
          "text": "Estas cookies nos ayudan a entender cómo los visitantes usan nuestro sitio. Permiten medir y analizar:"
        },
        {
          "type": "ul",
          "items": [
            "Tráfico del sitio",
            "Páginas vistas",
            "Comportamiento del visitante",
            "Tiempo en páginas",
            "Rendimiento técnico",
            "Interacción con funciones del sitio"
          ]
        },
        {
          "type": "p",
          "text": "Esta información nos ayuda a mejorar la estructura, el contenido, la velocidad y la usabilidad de www.demaxtore.com."
        },
        {
          "type": "p",
          "text": "Las cookies de analítica solo se utilizan cuando la ley lo permite y, si es necesario, con su consentimiento."
        }
      ]
    },
    {
      "title": "4.3 Cookies funcionales",
      "blocks": [
        {
          "type": "p",
          "text": "Las cookies funcionales permiten que el sitio recuerde sus elecciones y ofrezca funciones mejoradas."
        },
        {
          "type": "p",
          "text": "Pueden incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Preferencias de idioma",
            "Preferencias de región",
            "Información de formularios introducida previamente",
            "Preferencias de interfaz",
            "Mejoras de la experiencia de usuario"
          ]
        },
        {
          "type": "p",
          "text": "Si estas cookies están desactivadas, algunas funciones personalizadas pueden no funcionar correctamente."
        }
      ]
    },
    {
      "title": "4.4 Cookies de marketing y publicidad",
      "blocks": [
        {
          "type": "p",
          "text": "Las cookies de marketing pueden utilizarse para ofrecer contenido más relevante, medir campañas y evaluar la eficacia publicitaria."
        },
        {
          "type": "p",
          "text": "Pueden recopilar información sobre su navegación en nuestro sitio y, en algunos casos, en otros sitios."
        },
        {
          "type": "p",
          "text": "Pueden ser colocadas por DeMaxtore o por proveedores publicitarios y de analítica de terceros, según las herramientas utilizadas."
        },
        {
          "type": "p",
          "text": "Las cookies de marketing solo se utilizan con su consentimiento cuando la ley lo exige."
        }
      ]
    },
    {
      "title": "4.5 Cookies de terceros",
      "blocks": [
        {
          "type": "p",
          "text": "Nuestro sitio puede depender de servicios de terceros para mejorar la funcionalidad, interactividad, analítica, comunicación o marketing."
        },
        {
          "type": "p",
          "text": "Estos servicios pueden incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Proveedores de analítica",
            "Plataformas publicitarias",
            "Vídeo o medios integrados",
            "Chat o mensajería",
            "Integraciones de redes sociales",
            "CRM, formularios o seguimiento",
            "Herramientas de seguridad y rendimiento"
          ]
        },
        {
          "type": "p",
          "text": "Estos terceros pueden colocar cookies directamente en su dispositivo cuando interactúa con sus servicios en nuestro sitio."
        },
        {
          "type": "p",
          "text": "Mediante estas cookies, los terceros pueden recopilar y utilizar sus datos de navegación para sus propios fines, incluidos analítica, publicidad dirigida, personalización o mejora del servicio."
        },
        {
          "type": "p",
          "text": "Para más información, consulte las políticas de privacidad y cookies de los proveedores pertinentes."
        }
      ]
    },
    {
      "title": "5. Cookies para el funcionamiento del sitio",
      "blocks": [
        {
          "type": "p",
          "text": "Algunas cookies son necesarias para las funciones clave del sitio. Ayudan a garantizar que:"
        },
        {
          "type": "ul",
          "items": [
            "El sitio cargue correctamente",
            "Los formularios de contacto funcionen",
            "Las funciones de seguridad operen",
            "Se mantengan las sesiones de usuario",
            "Se recuerden las elecciones de cookies",
            "Las funciones del sitio permanezcan estables"
          ]
        },
        {
          "type": "p",
          "text": "Sin estas cookies, algunas partes del sitio pueden no funcionar como se pretende."
        }
      ]
    },
    {
      "title": "6. Cookies para mejorar la interactividad",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore puede utilizar herramientas de terceros para mejorar la interactividad del sitio, por ejemplo:"
        },
        {
          "type": "ul",
          "items": [
            "Vídeos integrados",
            "Formularios interactivos",
            "Chat en vivo",
            "Compartir en redes sociales",
            "Visualización de contenido externo",
            "Paneles de analítica",
            "Seguimiento de campañas de marketing"
          ]
        },
        {
          "type": "p",
          "text": "Estas funciones pueden usar cookies de terceros colocadas directamente por los proveedores."
        },
        {
          "type": "p",
          "text": "Si no da su consentimiento, parte del contenido interactivo o funciones de terceros pueden no estar disponibles."
        }
      ]
    },
    {
      "title": "7. Consentimiento de cookies",
      "blocks": [
        {
          "type": "p",
          "text": "Cuando la ley aplicable lo exige, solicitamos su consentimiento antes de colocar cookies no esenciales en su dispositivo."
        },
        {
          "type": "p",
          "text": "Usted puede:"
        },
        {
          "type": "ul",
          "items": [
            "Aceptar todas las cookies",
            "Rechazar cookies no esenciales",
            "Gestionar preferencias por categoría",
            "Retirar su consentimiento en cualquier momento"
          ]
        },
        {
          "type": "p",
          "text": "Si retira su consentimiento, las cookies ya colocadas pueden permanecer en su dispositivo hasta que las elimine en el navegador o hasta que expiren."
        }
      ]
    },
    {
      "title": "8. Cómo gestionar las cookies",
      "blocks": [
        {
          "type": "p",
          "text": "Puede gestionar las cookies de dos maneras:"
        },
        {
          "type": "p",
          "text": "Mediante nuestra herramienta de preferencias de cookies"
        },
        {
          "type": "p",
          "text": "Cuando esté disponible, puede gestionar sus preferencias a través del banner de cookies o del panel de configuración en nuestro sitio."
        },
        {
          "type": "p",
          "text": "Mediante la configuración del navegador"
        },
        {
          "type": "p",
          "text": "La mayoría de los navegadores permiten:"
        },
        {
          "type": "ul",
          "items": [
            "Ver las cookies almacenadas",
            "Eliminar cookies",
            "Bloquear cookies",
            "Establecer preferencias por sitio",
            "Recibir avisos antes de almacenar cookies"
          ]
        },
        {
          "type": "p",
          "text": "Bloquear todas las cookies puede afectar la funcionalidad y el rendimiento de nuestro sitio."
        }
      ]
    },
    {
      "title": "9. Responsabilidad de terceros",
      "blocks": [
        {
          "type": "p",
          "text": "Las cookies de terceros son controladas por los proveedores correspondientes. DeMaxtore no controla plenamente cómo los terceros usan las cookies ni procesan los datos recopilados mediante sus tecnologías."
        },
        {
          "type": "p",
          "text": "Le recomendamos revisar las políticas de privacidad y cookies de los servicios de terceros con los que interactúa a través de nuestro sitio."
        }
      ]
    },
    {
      "title": "10. Cambios en esta política de cookies",
      "blocks": [
        {
          "type": "p",
          "text": "Podemos actualizar esta política de cookies para reflejar cambios en nuestro sitio, el uso de cookies, herramientas de terceros, requisitos legales u operaciones comerciales."
        },
        {
          "type": "p",
          "text": "Cualquier actualización se publicará en esta página con la fecha de «Última actualización» revisada."
        }
      ]
    },
    {
      "title": "11. Contacto",
      "blocks": [
        {
          "type": "p",
          "text": "Para preguntas sobre esta política de cookies o nuestro uso de cookies, contáctenos:"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "Marca operativa: DeMaxtore",
            "Sitio web: www.demaxtore.com",
            "Correo electrónico: support@demaxtore.com",
            "Correo alternativo: demaxtore@demaxtore.com"
          ]
        }
      ]
    }
  ]
};
